import { BedDoubleIcon } from './BedDoubleIcon';

/**
 * author: Michael Richins
 * id 76E0CC3D-3FF4-421A-A7F0-0F38C68C92A2
 * name bed-double
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-double.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const BedroomIcon = BedDoubleIcon;
export default BedroomIcon